import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const stats = [
  {
    number: '3X',
    label: 'Average Profit Increase in 30 Days',
    sub: 'Verified across 40+ active client accounts. Not a promise — a track record.',
  },
  {
    number: '2.8M+',
    label: 'Views Generated for Clients',
    sub: 'Real eyeballs, targeted audiences, zero wasted impressions.',
  },
  {
    number: '1.4M+',
    label: 'Likes & Comments Delivered',
    sub: 'Engagement that converts. Attention that sells. Results that compound.',
  },
];

export default function Results() {
  const ref = useScrollAnimation();

  return (
    <section id="results" className="bg-black border-y border-white/5 py-24 md:py-32">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-20 fade-in-up">
          <p className="text-electric-blue text-xs font-semibold tracking-widest uppercase mb-4">
            The CGOeight System in Action
          </p>
          <h2 className="font-display font-bold text-white leading-tight"
            style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
          >
            Proof Is in the Performance.
          </h2>
          <p className="text-white/35 text-sm mt-3 tracking-wide">
            AI-Powered Performance Marketing — real numbers, real clients, real results.
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
          {stats.map((stat, i) => (
            <div
              key={stat.number}
              className={`fade-in-up text-center py-12 px-8 ${
                i < stats.length - 1
                  ? 'border-b md:border-b-0 md:border-r border-white/8'
                  : ''
              }`}
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <div
                className="font-display font-bold text-electric-blue leading-none mb-4 text-glow-blue"
                style={{ fontSize: 'clamp(3.5rem, 7vw, 6rem)' }}
              >
                {stat.number}
              </div>
              <div className="text-white font-semibold text-base md:text-lg mb-3 leading-snug">
                {stat.label}
              </div>
              <p className="text-white/35 text-sm leading-relaxed max-w-xs mx-auto">
                {stat.sub}
              </p>
            </div>
          ))}
        </div>

        {/* Divider line */}
        <div className="mt-20 h-px bg-gradient-to-r from-transparent via-electric-blue/20 to-transparent fade-in-up" />

        {/* System badge */}
        <div className="mt-10 fade-in-up flex justify-center">
          <div className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full border border-electric-blue/20 bg-electric-blue/5">
            <i className="ri-cpu-line text-electric-blue text-sm" />
            <span className="text-electric-blue/80 text-xs font-semibold tracking-widest uppercase">
              Powered by The CGOeight System — AI-Powered Performance Marketing
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
